import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import CachedIcon from '@mui/icons-material/Cached';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { convertEpochToTimestamp } from '../../utils';
import IosShareIcon from '@mui/icons-material/IosShare';
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action';
import { ButtonBase, CircularProgress } from '@mui/material';
import DrawerComponent from './DrawerComponent'
import { getSearchSuggestionDetailRecord, getInlineImage, getAnswerRatings,getSearchSuggestionsForCMRecords, getSearchSuggestionsCount, getKeyTag } from '../../API/api';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home_PAGE_URL } from '../../Router/routerUrl';
import Pagination from '@mui/material/Pagination';
import Chip from '@mui/material/Chip';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import VizParagraph from '../../Component/VizParagraph/VizParagraph';
import { Tag } from 'antd';

const theme = createTheme({
	components: {
		MuiTableHead: {
			styleOverrides: {
				root: {
					minHeight: '25px',
				},
			},
		},
		MuiTableCell: {
			styleOverrides: {
				root: {
					padding: '0px',
					textAlign: 'center'
				}
			}
		},
	},
});

const ellipsisStyle = {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
	height:'35px'
}




export default function TableComponentForSearchSuggestions() {
	const searchSuggestionsReducer = useSelector((state) => state.searchSuggestionsCM);
	const state = useSelector(state=>state.cmRoot);
	const userState = useSelector((state) => state.user);
	const [order, setOrder] = React.useState('asc');
	const [orderBy, setOrderBy] = React.useState('calories');
	// const [selected, setSelected] = React.useState(searchSuggestionsReducer.deletedQuestions);
	const [selected, setSelected] = React.useState([])
	// const [page, setPage] = React.useState(searchSuggestionsReducer.page);
	const [page, setPage] = React.useState(1);
	const [dense, setDense] = React.useState(false);
	const [rowsPerPage, setRowsPerPage] = React.useState(20);
	const dispatch = useDispatch();
	const [visibleRows, setVisibleRows] = React.useState([])
	const [answerUuid, setAnswerUuid] = React.useState([]);
	const currentPath = useLocation();
	const [pageFrom, setPageFrom] = React.useState(1)
	const [getDataLength, setDataLength] = React.useState(0);
	const [pageTo, setPageTo] = React.useState(getDataLength)
	const [onPageClick, onChangePageClick] = React.useState(false);
	const { getQuestionsSubmittedData,bestResultsToggleCM,genAIAnswerToggleCM,getGenAIOverallRatingsData,getGenAiAnswerSummary,showEmptySuggestionsContent,getDislikesInSearchSuggestions,SearchSuggestionsDataCM, searchSuggestionsDataCountCM,updatePageNoInSearchSuggestions, advanceFilterModalToggle, deleteQuestionInSearchSuggestions, getLoadingStatusForSearchSuggestions, searchSuggestionsDetails, searchSuggestionsQuestionText, getSeekerNameInSearchSuggestions, getUserTypeInSearchSuggestions, getPostedDateInSearchSuggestions, getTagsDataInSearchSuggestions, getSearchFilterForEmailFilter, getAcceptedQuestionFilter, getSourceFilterInSearchSuggestions, getSeekerFilterInSearchSuggestions, getSourceFilterForFromDate, getSourceFilterForTillDate, getDomainNameInSearchSuggestions, getSourceFilterForDomains, getExpertFilterInSearchSuggestions, getAskedSourceForSearchSuggestions, resetRatingsData, clearExpertsOnClick, getCheckForDeletedItems, getDeletedItemsInSearchSuggestions,checkForDeleteAPICall,cmRootUpdateDomainVal,getDomainNameInSearchSuggestionsDetailPage } = bindActionCreators(Actions, dispatch);
	const navigate = useNavigate();
	const [isChecked, setIsChecked] = React.useState(searchSuggestionsReducer.isItemsDelete);

	function createData(id, questionTopicUuid, questionText, suggestionCount, postedDate, seekerName, domain, userType, tags, accepted, source, searchMethod, acceptedCount, answeredCount, openCount, rejectedCount,bestResult,summaryId,
		genAIAnswer,
		submitted,
		genAIOverallRating) {
		return {
			id,
			questionTopicUuid,
			questionText,
			suggestionCount,
			postedDate,
			seekerName,
			domain,
			userType,
			tags,
			accepted,
			source,
			searchMethod,
			acceptedCount,
			answeredCount,
			openCount,
			rejectedCount,
			bestResult,
			summaryId,
			genAIAnswer,
			submitted,
			genAIOverallRating
		};
	}

	const dataRows = [];


	function descendingComparator(a, b, orderBy) {
		if (b[orderBy] < a[orderBy]) {
			return -1;
		}
		if (b[orderBy] > a[orderBy]) {
			return 1;
		}
		return 0;
	}

	function getComparator(order, orderBy) {
		return order === 'desc'
			? (a, b) => descendingComparator(a, b, orderBy)
			: (a, b) => -descendingComparator(a, b, orderBy);
	}

	let arrayOfDigits = Array.from(String(searchSuggestionsReducer.domainIds), Number);

	// setIsChecked(() => {
	// 	if (searchSuggestionsReducer.isItemsDelete === true) {
	// 		setSelected([])
	// 	}
	// })



	function EnhancedTableHead(props) {
		const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
			props;

		const createSortHandler = (property) => (event) => {
			onRequestSort(event, property);
		};

		return (
			<ThemeProvider theme={theme}>
				<TableHead style={ellipsisStyle}>
					<TableRow>
						<TableCell>
							<Checkbox
								size='small'
								style={{ padding: '0px 0px 4px 4px' }}
								color="primary"
								// indeterminate={numSelected > 0 && numSelected < rowCount && searchSuggestionsReducer.deletedQuestions.length > 0}
								indeterminate={numSelected > 0 && numSelected < rowCount}
								// checked={(rowCount > 0 && (numSelected === rowCount) && (searchSuggestionsReducer.deletedQuestions.length > 0))}
								checked={(rowCount > 0 && (numSelected === rowCount))}
								onChange={onSelectAllClick}
								inputProps={{
									'aria-label': 'select all questions',
								}}
							/>
						</TableCell>
						{headCells.map((headCell) => (
							<>
								<TableCell
									style={{ width: `${headCell.width}%` }}
									key={headCell.id}
									align={headCell.numeric ? 'right' : 'left'}
									padding={headCell.disablePadding ? 'none' : 'normal'}
									sortDirection={orderBy === headCell.id ? order : false}
								>
								</TableCell>
							</>
						))}
					</TableRow>
				</TableHead>
			</ThemeProvider>
		);
	}

	function stableSort(array, comparator) {
		const stabilizedThis = array.map((el, index) => [el, index]);
		stabilizedThis.sort((a, b) => {
			const order = comparator(a[0], b[0]);
			if (order !== 0) {
				return order;
			}
			return a[1] - b[1];
		});
		return stabilizedThis.map((el) => el[0]);
	}



	const headCells = [
		{
			id: 'questionText',
			disablePadding: true,
			sortable: false,
			width: '83',
		},
		{
			id: 'postedDate',
			disablePadding: false,
			width: "17"
		},
	];



	EnhancedTableHead.propTypes = {
		numSelected: PropTypes.number.isRequired,
		onRequestSort: PropTypes.func.isRequired,
		onSelectAllClick: PropTypes.func.isRequired,
		order: PropTypes.oneOf(['asc', 'desc']).isRequired,
		orderBy: PropTypes.string.isRequired,
		rowCount: PropTypes.number.isRequired,
	};

	function FiltersToolbar(props) {
		const { numSelected,onSelectAllClick, order, orderBy, rowCount, onRequestSort } =
		props;
		const onClickDeleteModal = () => {
			advanceFilterModalToggle({ bool: true, value: "deleteQuestion" })
		}

		const onClickDataExportModal = () => {
			advanceFilterModalToggle({ bool: true, value: "dataExportFilter" })
		}

		const onClickExcludeAcceptedFilter = () => {
			getAcceptedQuestionFilter(null);
			updatePageNoInSearchSuggestions(0)
		}

		const onClickRemoveSourceFilter = () => {
			getSourceFilterInSearchSuggestions('')
			updatePageNoInSearchSuggestions(0)
		}

		const handleDelete = () => {
			getSearchFilterForEmailFilter(true)
			updatePageNoInSearchSuggestions(0)
		};

		let output2 = Object.keys(userState.cmTopics !== undefined && userState.cmTopics).map((k) => userState.cmTopics[k]);

		const onClickRemoveSeekers = () => {
			resetRatingsData()
			updatePageNoInSearchSuggestions(0)
		}

		const onClickClearForDate = () => {
			getSourceFilterForFromDate('')
			updatePageNoInSearchSuggestions(0)
		}

		const onClickClearTillDate = () => {
			getSourceFilterForTillDate('')
			updatePageNoInSearchSuggestions(0)
		}

		const onClickDomainFilters = () => {
			// getDomainNameInSearchSuggestions('')
			// getSourceFilterForDomains('')
			cmRootUpdateDomainVal([])
		}

		const onClickRemoveExperts = () => {
			clearExpertsOnClick()
			updatePageNoInSearchSuggestions(0)
		}

		const onClickDislikesFilter = () => {
			updatePageNoInSearchSuggestions(0)
			getDislikesInSearchSuggestions('')
		}
		
		const onClickEmptySuggestions = () => {
			updatePageNoInSearchSuggestions(0)
			showEmptySuggestionsContent('')
		}

		const onClickGenAIAnswerClear = () => {
			updatePageNoInSearchSuggestions(0)
			genAIAnswerToggleCM('')
		}

		const onClickBestResultsToggleClear = () => {
			updatePageNoInSearchSuggestions(0)
			bestResultsToggleCM('')
		}

		const onClickQuestionSubmittedClear = () => {
			updatePageNoInSearchSuggestions(0)
			getQuestionsSubmittedData('')
		}
		return (
			<>
				<Toolbar
					sx={{
						paddingLeft:'8px',
						paddingRight:'3px',
						display: 'flex',
						//  justifyContent: 'space-between',
						alignItems: 'center',
						// ...(numSelected > 0 && searchSuggestionsReducer.isItemsDelete !== true && {
						// 	bgcolor: (theme) =>
						// 		alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
						// }),
						borderBottom:'1px solid lightgrey'
					}}
					variant="dense"
					disableGutters
				>
					<Checkbox size='small' 
					disableRipple
					style={{ padding: '0px 0px 4px 4px' }}
					color="primary"
					// indeterminate={numSelected > 0 && numSelected < rowCount && searchSuggestionsReducer.deletedQuestions.length > 0}
					indeterminate={numSelected > 0 && numSelected < rowCount}
					// checked={(rowCount > 0 && (numSelected === rowCount) && (searchSuggestionsReducer.deletedQuestions.length > 0))}
					checked={(rowCount > 0 && (numSelected === rowCount))}
					onChange={onSelectAllClick}
					inputProps={{
						'aria-label': 'select all questions',
					}}
					/>
					<div style={{width:'100%',display:'flex',justifyContent:'space-between',alignItems:'baseline'}}>
					<div className='listOfFilters'>
						{searchSuggestionsReducer.excludeEmail === false
							&&
							<Chip label="Filter: Include Email Questions" sx={{ cursor: 'pointer', borderRadius: '6px', margin: '3px' }} variant="outlined" onDelete={handleDelete} />
						}
						{/* {
							state2.selectedDomainsObj.length === 1 &&
							<Tooltip title={state2.selectedDomainsObj.map((obj)=>{return obj.name})}>
							<Chip onDelete={onClickDomainFilters} label={`Domains:${state2.selectedDomainsObj.map((obj) => { return obj.name })}`}
								variant='outlined' sx={{ borderRadius: '6px', cursor: 'pointer' }} />
							</Tooltip>
						}
						{
							state2.selectedDomainsObj.length > 1 &&
							<Tooltip title={
								<>
								{
									state2.selectedDomainsObj.slice(1).map((ob,i)=>{
										return(
											<>
											<span style={{fontWeight:'bold'}} key={i}>{ob.name}</span>
											<br />
											</>
										)
									})
								}
								</>
							}>
								<Chip onDelete={onClickDomainFilters} label={`Domains:${state2.selectedDomainsObj[0].name} ` + `+ ${state2.selectedDomainsObj.length - 1} more`}
									variant='outlined' sx={{ borderRadius: '6px', cursor: 'pointer' }} />
							</Tooltip>
						} */}
						{
							searchSuggestionsReducer.fromDate !== '' &&
							<Chip onDelete={onClickClearForDate} label={`From: ${moment(searchSuggestionsReducer.fromDate).format('LL')}`} sx={{ cursor: 'pointer', borderRadius: '6px', margin: '3px' }} variant='outlined' />
						}
						{
							searchSuggestionsReducer.tillDate !== '' &&
							<Chip onDelete={onClickClearTillDate} label={`Till: ${moment(searchSuggestionsReducer.tillDate).format('LL')}`} variant='outlined' sx={{ borderRadius: '6px', margin: '3px', cursor: 'pointer' }} />
						}
						{
							searchSuggestionsReducer.source !== '' &&
							<Chip  label={`Source: ${searchSuggestionsReducer.source}`} sx={{ cursor: 'pointer', borderRadius: '6px', margin: '3px',textTransform:'capitalize' }} variant="outlined" onDelete={onClickRemoveSourceFilter} />
						}
						{
							searchSuggestionsReducer.isAccepted === true &&
							<Chip sx={{ cursor: 'pointer', borderRadius: '6px', margin: '3px' }} label="Likes" variant='outlined' onDelete={onClickExcludeAcceptedFilter} />
						}
						{
							searchSuggestionsReducer.getDislikes && 
							<Chip sx={{cursor: 'pointer', borderRadius: '6px', margin: '3px'}} label="Dislikes" variant='outlined' onDelete={onClickDislikesFilter}></Chip>
						}
						{
						searchSuggestionsReducer.isEmpty && 
						<Chip sx={{cursor: 'pointer', borderRadius: '6px', margin: '3px'}} label="Empty Suggestions" variant='outlined' onDelete={onClickEmptySuggestions}></Chip>
						}
						{
							searchSuggestionsReducer.genAIToggle && 
							<Chip sx={{cursor: 'pointer', borderRadius: '6px', margin: '3px'}} label="GenAI Answers" variant='outlined' onDelete={onClickGenAIAnswerClear}></Chip>
						}
						{
							searchSuggestionsReducer.bestResultToggle && 
							<Chip sx={{cursor: 'pointer', borderRadius: '6px', margin: '3px'}} label="Best Results" variant='outlined' onDelete={onClickBestResultsToggleClear}></Chip>
						}
						{
							searchSuggestionsReducer.qSubmitted && 
							<Chip sx={{cursor: 'pointer', borderRadius: '6px', margin: '3px'}} label="Questions Submitted" variant="outlined" onDelete={onClickQuestionSubmittedClear} />
						}
						{/* searchSuggestionsReducer.seekersListInfo.map((usr,ind)=>
										{return usr.firstName + " " + usr.lastName + (ind === searchSuggestionsReducer.seekersListInfo.length - 1 ? " " : ", ")})} */}
						{
							searchSuggestionsReducer.seekersListInfo.length > 1 &&
							<Tooltip placement='bottom-end' sx={{ whiteSpace: 'pre-line' }} title={
								<>
									{
										searchSuggestionsReducer.seekersListInfo.length > 1 ?
											searchSuggestionsReducer.seekersListInfo.slice(1).map((usr, ind) => {
												return (
													<>
														<span style={{ fontWeight: 'bold' }}>
															{usr.firstName}{" "}{usr.lastName + (ind === searchSuggestionsReducer.seekersListInfo.length - 2 ? " " : ", ")}
														</span>
														<br />
													</>
												)
											}) : ""
									}
								</>
							}>
								<Chip variant='outlined' onDelete={onClickRemoveSeekers} sx={{ cursor: 'pointer', borderRadius: '6px', margin: '3px' }} label={searchSuggestionsReducer.seekersListInfo.length === 1 ? `Seeker: ${searchSuggestionsReducer.seekersListInfo[0].firstName}${" "}${searchSuggestionsReducer.seekersListInfo[0].lastName}` : `Seekers: ${searchSuggestionsReducer.seekersListInfo[0].firstName}${" "}${searchSuggestionsReducer.seekersListInfo[0].lastName}${" "}+${searchSuggestionsReducer.seekersListInfo.length > 1 && searchSuggestionsReducer.seekersListInfo.length - 1}${" "}more`} />
							</Tooltip>
						}
						{
							searchSuggestionsReducer.seekersListInfo.length > 0
							&&
							searchSuggestionsReducer.seekersListInfo.length === 1 &&
							<Chip onDelete={onClickRemoveSeekers} variant='outlined' sx={{ cursor: 'pointer', borderRadius: '6px', margin: '3px' }} label={`Seeker: ${searchSuggestionsReducer.seekersListInfo[0].firstName}${" "}${searchSuggestionsReducer.seekersListInfo[0].lastName}`} />
						}
						{
							searchSuggestionsReducer.expertsListInfo.length > 1 &&
							<Tooltip placement='bottom-end' sx={{ whiteSpace: 'pre-line' }} title={
								<>
									{
										searchSuggestionsReducer.expertsListInfo.length > 1 ?
											searchSuggestionsReducer.expertsListInfo.slice(1).map((usr, ind) => {
												return (
													<>
														<span style={{ fontWeight: 'bold' }}>
															{usr.firstName}{" "}{usr.lastName + (ind === searchSuggestionsReducer.expertsListInfo.length - 2 ? " " : ", ")}
														</span>
														<br />
													</>
												)
											}) : ""
									}
								</>
							}>
								<Chip onDelete={onClickRemoveExperts} variant='outlined' sx={{ cursor: 'pointer', borderRadius: '6px', margin: '3px' }} label={searchSuggestionsReducer.expertsListInfo.length === 1 ? `Expert: ${searchSuggestionsReducer.expertsListInfo[0].firstName}${" "}${searchSuggestionsReducer.expertsListInfo[0].lastName}` : `Experts: ${searchSuggestionsReducer.expertsListInfo[0].firstName}${" "}${searchSuggestionsReducer.expertsListInfo[0].lastName}${" "}+${searchSuggestionsReducer.expertsListInfo.length > 1 && searchSuggestionsReducer.expertsListInfo.length - 1}${" "}more`} />
							</Tooltip>
						}
						{
							searchSuggestionsReducer.expertsListInfo.length > 0
							&&
							searchSuggestionsReducer.expertsListInfo.length === 1 &&
							<>
								<Chip onDelete={onClickRemoveExperts} variant='outlined' sx={{ cursor: 'pointer', borderRadius: '6px', margin: '3px' }} label={`Expert ${searchSuggestionsReducer.expertsListInfo[0].firstName}${" "}${searchSuggestionsReducer.expertsListInfo[0].lastName}`} />
							</>
						}
					</div>
					<div>
						{(
						<>
							<div style={{ display: 'flex' }}>
								<Tooltip title="Filter list">
									<DrawerComponent />
								</Tooltip>
								<Tooltip title="Export Data">
									<IconButton onClick={() => onClickDataExportModal()}>
										<IosShareIcon />
									</IconButton>
								</Tooltip>
							<Tooltip title="Refresh List">
								<IconButton onClick={()=>onClickRefresh()}>
								<CachedIcon sx={{ cursor: 'pointer', margin: '3px' }} />
								</IconButton>
							</Tooltip>
							</div>
						</>
						)}
					</div>
					</div>
				</Toolbar>
			</>
		)
	}


	function EnhancedTableToolbar(props) {
		const { numSelected } = props;

		const onClickDeleteModal = () => {
			advanceFilterModalToggle({ bool: true, value: "deleteQuestion" })
		}

		const onClickDataExportModal = () => {
			advanceFilterModalToggle({ bool: true, value: "dataExportFilter" })
		}

		const onClickExcludeAcceptedFilter = () => {
			getAcceptedQuestionFilter(null);
			updatePageNoInSearchSuggestions(0)
		}

		const onClickRemoveSourceFilter = () => {
			getSourceFilterInSearchSuggestions('')
			updatePageNoInSearchSuggestions(0)
		}

		const handleDelete = () => {
			getSearchFilterForEmailFilter(false)
			updatePageNoInSearchSuggestions(0)
		};

		let output2 = Object.keys(userState.cmTopics !== undefined && userState.cmTopics).map((k) => userState.cmTopics[k]);

		const onClickRemoveSeekers = () => {
			resetRatingsData()
			updatePageNoInSearchSuggestions(0)
		}

		const onClickClearForDate = () => {
			getSourceFilterForFromDate('')
			updatePageNoInSearchSuggestions(0)
		}

		const onClickClearTillDate = () => {
			getSourceFilterForTillDate('')
			updatePageNoInSearchSuggestions(0)
		}

		const onClickDomainFilters = () => {
			getDomainNameInSearchSuggestions('')
			getSourceFilterForDomains('')
		}

		const onClickRemoveExperts = () => {
			clearExpertsOnClick()
			updatePageNoInSearchSuggestions(0)
		}


		return (
			<Toolbar
				sx={{
					pl: { sm: 2 },
					pr: { xs: 1, sm: 1 },
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'baseline',
					...(numSelected > 0 && {
						bgcolor: (theme) =>
							alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
					}),
				}}
				variant="dense"
			>
				{(numSelected > 0) ? (
					<Typography
						sx={{ flex: '1 1 100%', alignItems: 'baseline' }}
						color="inherit"
						variant="subtitle1"
						component="div"
					>
						{numSelected} selected
					</Typography>
				) : (
					// <Typography
					// 	sx={{ paddingTop: '4px', paddingBottom: '4px', display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}
					// 	variant="h6"
					// 	id="tableTitle"
					// 	component="div"
					// >
					// 	Vizerto Search History
					// 	<div>
					// 		{searchSuggestionsReducer.count > 0 && <div className="searchSuggestionsCount">
					// 			{/* {searchSuggestionsReducer.page === 0 ? "1" : searchSuggestionsReducer.page + 1} to {searchSuggestionsReducer.searchSuggestionsData.length} of {searchSuggestionsReducer.count} */}
					// 			{/* {searchSuggestionsReducer.page > 0 ? pageFrom : "1"} to {searchSuggestionsReducer.page > 0 ? pageTo : getDataLength} of {searchSuggestionsReducer.count} */}
					// 			{
					// 				searchSuggestionsReducer.page === 0 ? <><span>1 to {searchSuggestionsReducer.searchSuggestionsData.length} of {searchSuggestionsReducer.count}</span></>
					// 					:
					// 					<>
					// 						<span>
					// 							{(searchSuggestionsReducer.page === (Math.ceil(searchSuggestionsReducer.count / 20) - 1)) ? (searchSuggestionsReducer.count - searchSuggestionsReducer.searchSuggestionsData.length) + 1 : searchSuggestionsReducer.page * searchSuggestionsReducer.searchSuggestionsData.length + 1}
					// 							{" "}to{" "}
					// 							{searchSuggestionsReducer.page === (Math.ceil(searchSuggestionsReducer.count / 20) - 1) ? searchSuggestionsReducer.count : ((searchSuggestionsReducer.page) * (searchSuggestionsReducer.searchSuggestionsData.length) + (searchSuggestionsReducer.searchSuggestionsData.length))}
					// 							{" "}of{" "}{searchSuggestionsReducer.count}
					// 						</span>
					// 					</>
					// 			}
					// 		</div>}
					// 	</div>
					// </Typography>
					null
				)}
				{(numSelected > 0 && searchSuggestionsReducer.isAPICalled === false) ? (
					<>
						<Tooltip title="Delete">
							<IconButton disabled={searchSuggestionsReducer.isAPICalled && true} onClick={() => onClickDeleteModal()}>
								<DeleteIcon />
							</IconButton>
						</Tooltip>
					</>
				) : 
				// (searchSuggestionsReducer.isAPICalled === false) && (
				// 	<>
				// 		<div style={{ display: 'flex' }}>
				// 			<Tooltip title="Filter list">
				// 				<DrawerComponent />
				// 			</Tooltip>
				// 			<Tooltip title="Export Data">
				// 				<IconButton onClick={() => onClickDataExportModal()}>
				// 					<IosShareIcon />
				// 				</IconButton>
				// 			</Tooltip>
				// 		</div>
				// 	</>
				// )
				null
				}
				{
					(numSelected > 0 && searchSuggestionsReducer.isAPICalled) &&
					(
						<IconButton sx={{cursor:'default'}}>
						<CircularProgress size="16px" />
						</IconButton>
					)
				}
			</Toolbar>
		);
	}

	EnhancedTableToolbar.propTypes = {
		numSelected: PropTypes.number.isRequired,
	};

	// const handleRequestSort = (event, property) => {
	// 	const isAsc = orderBy === property && order === 'asc';
	// 	setOrder(isAsc ? 'desc' : 'asc');
	// 	setOrderBy(property);
	// };

	const handleSelectAllClick = (event) => {
		if (event.target.checked) {
			const newSelected = visibleRows.map((n) => n.id);
			setSelected(newSelected);
			deleteQuestionInSearchSuggestions(newSelected.toString())
			getDeletedItemsInSearchSuggestions(newSelected);
			return;
		}
		setSelected([]);
	};

	// if(searchSuggestionsReducer.getQuestionUuid !== null)
	// {	
	// 		setSelected([])
	// }


	const handleClick = (event, id) => {
		// if(event.target.checked){
		// 	setSelected([...selected, id.id]);
		// 	console.log(selected,"check check")
		// 	getDeletedItemsInSearchSuggestions(selected.toString())
		// 	console.log(searchSuggestionsReducer,"check payload going")
		// 	deleteQuestionInSearchSuggestions(selected.toString())
		// }else{
		// 	let newData = selected.filter(obj=>{
		// 		if(obj !== id.id){
		// 			return obj;
		// 		}
		// 	});
		// 	setSelected(newData);
		// 	getDeletedItemsInSearchSuggestions(selected.toString())
		// 	deleteQuestionInSearchSuggestions(selected.toString())
		// 	console.log('clicked',"check payload")
		// }
		const selectedIndex = selected.indexOf(id);
		let newSelected = [];
		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, id);
			deleteQuestionInSearchSuggestions(newSelected.toString());
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
			deleteQuestionInSearchSuggestions(newSelected.toString());
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
			deleteQuestionInSearchSuggestions(newSelected.toString());
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1),
			);
			deleteQuestionInSearchSuggestions(newSelected.toString());
		}
		setSelected(newSelected);
	};


	const handleChangePage = (event, newPage) => {
		updatePageNoInSearchSuggestions(newPage - 1);
		setPage(newPage)
		onChangePageClick(true);
		setSelected([])
		// if(searchSuggestionsReducer.page === 0)
		// {
		// 	setPage(1)
		// }
		// if(searchSuggestionsReducer.page > 0)
		// {
		// 	setPage(newPage)
		// }
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		updatePageNoInSearchSuggestions(0);
	};

	const handleChangeDense = (event) => {
		setDense(event.target.checked);
	};

	const isSelected = (id) => selected.indexOf(id) !== -1;

	const emptyRows =
		searchSuggestionsReducer.page > 0 ? Math.max(0, (1 + searchSuggestionsReducer.page) * rowsPerPage - dataRows.length) : 0;


		const onClickRefresh = () => {
			let payloadForCMCount = {
				page: searchSuggestionsReducer.page,
				// excludeEmail: searchSuggestionsReducer.excludeEmail,
				domains: searchSuggestionsReducer.domainIds.toString(),
				geoLevelId:state.selecetdRoutingValue, 
				// geoLevelValue: console.log(searchSuggestionsReducer.geoLevelValue.replace(/"/g, '')),
				geoLevelValue:state.selectedGeoLevel.name,
				...(searchSuggestionsReducer.source === 'email') ? {excludeEmail:false} :{excludeEmail:searchSuggestionsReducer.excludeEmail},
				...(searchSuggestionsReducer.isAccepted === true && { accepted: searchSuggestionsReducer.isAccepted }),
				...(searchSuggestionsReducer.source !== '' && { source: searchSuggestionsReducer.source }),
				...(searchSuggestionsReducer.fromDate !== '' && { updatedFromDate: searchSuggestionsReducer.fromDate }),
				...(searchSuggestionsReducer.tillDate !== '' && { updatedToDate: searchSuggestionsReducer.tillDate + ` 23:59:59` }),
				...(searchSuggestionsReducer.seekers !== null && searchSuggestionsReducer.seekers.length > 0 && { seekers: searchSuggestionsReducer.seekers.toString() }),
				...(searchSuggestionsReducer.experts.length > 0 && { experts: searchSuggestionsReducer.experts.toString() }),
				...(state.selectedDomainIds !='' && { domains: state.selectedDomainIds }),
				...(searchSuggestionsReducer.isEmpty && {emptySuggestions:searchSuggestionsReducer.isEmpty}),
				...(searchSuggestionsReducer.getDislikes && {rejected:searchSuggestionsReducer.getDislikes}),
				...(searchSuggestionsReducer.genAIToggle) && {genAIAnswer:searchSuggestionsReducer.genAIToggle},
				...(searchSuggestionsReducer.bestResultToggle) && {bestResults:searchSuggestionsReducer.bestResultToggle},
				...(searchSuggestionsReducer.qSubmitted) && {submitted:searchSuggestionsReducer.qSubmitted}
			}
	
			let payloadForCMSearchRecords = {
				page: searchSuggestionsReducer.page,
				excludeEmail: searchSuggestionsReducer.excludeEmail,
				geoLevelId:state.selecetdRoutingValue, 
				geoLevelValue:state.selectedGeoLevel.name,
				...(searchSuggestionsReducer.source === 'email') ? {excludeEmail:false} :{excludeEmail:searchSuggestionsReducer.excludeEmail},
				...(searchSuggestionsReducer.isAccepted === true && { accepted: searchSuggestionsReducer.isAccepted }),
				...(searchSuggestionsReducer.source !== '' && { source: searchSuggestionsReducer.source }),
				...(searchSuggestionsReducer.fromDate !== '' && { updatedFromDate: searchSuggestionsReducer.fromDate }),
				...(searchSuggestionsReducer.tillDate !== '' && { updatedToDate: searchSuggestionsReducer.tillDate + " 23:59:59" }),
				...(searchSuggestionsReducer.seekers !== null && searchSuggestionsReducer.seekers.length > 0 && { seekers: searchSuggestionsReducer.seekers.toString() }),
				...(searchSuggestionsReducer.experts.length > 0 && { experts: searchSuggestionsReducer.experts.toString() }),
				...(state.selectedDomainIds !='' && { domains: state.selectedDomainIds }),
				...(searchSuggestionsReducer.isEmpty && {emptySuggestions:searchSuggestionsReducer.isEmpty}),
				...(searchSuggestionsReducer.getDislikes && {rejected:searchSuggestionsReducer.getDislikes}),
				...(searchSuggestionsReducer.genAIToggle) && {genAIAnswer:searchSuggestionsReducer.genAIToggle},
				...(searchSuggestionsReducer.bestResultToggle) && {bestResults:searchSuggestionsReducer.bestResultToggle},
				...(searchSuggestionsReducer.qSubmitted) && {submitted:searchSuggestionsReducer.qSubmitted}
			}
			getLoadingStatusForSearchSuggestions(true)
			// updatePageNoInSearchSuggestions(0)
			getSearchSuggestionsCount(payloadForCMCount).then((res) => {
				if (res===undefined) return;
				if (res.data.success === true || res.data.data !== undefined) {
					searchSuggestionsDataCountCM(res.data.data);
					getLoadingStatusForSearchSuggestions(false);
				}
			})
			getSearchSuggestionsForCMRecords(payloadForCMSearchRecords
			).then((res) => {
				if (res===undefined) return;
				if (res.data.data !== undefined || res.data.success) {
					SearchSuggestionsDataCM(res.data.data);
					getLoadingStatusForSearchSuggestions(false);
				}
			})
	
		}

	React.useEffect(() => {
		checkForDeleteAPICall(false)
		if (searchSuggestionsReducer.searchSuggestionsData !== undefined && searchSuggestionsReducer.searchSuggestionsData.length > 0) {
			searchSuggestionsReducer.searchSuggestionsData.forEach((item, i) => {
				dataRows.push(createData(item.questionUuid, item.questionTopicUuid, item.questionText, item.suggestionCount, item.postedDate, item.seekerName, item.domain, item.userType, item.tags, item.accepted, item.source, item.searchMethod, item.acceptedCount, item.answeredCount,
					item.openCount,
					item.rejectedCount,
					item.bestResult,
					item.summaryId,
					item.genAIAnswer,
					item.submitted,
					item.genAIOverallRating
					));
			})
		}
		setVisibleRows(dataRows)
		setPage(searchSuggestionsReducer.page + 1)
		setDataLength(searchSuggestionsReducer.searchSuggestionsData.length)
		setSelected([])
	}, [searchSuggestionsReducer?.searchSuggestionsData,])

	const momentit = (stime) => {
		if (Number(Date.now()) - Number(stime) < 259200000) {
			return moment(new Date(Number(stime))).fromNow();
		} else {
			return moment(convertEpochToTimestamp(stime)).format("ll");
		}
	};

	const onClickQuestionRecord = (questionUuid, seekerName, userType, questionText, postedDate, tags, source,domain,genAIAnswer,genAIOverallRating) => {
		navigate(`${Home_PAGE_URL}searchsuggestionrecords`)
		getKeyTag([questionUuid])
		if(source !== 'External Search'){
			getLoadingStatusForSearchSuggestions(true);
		getSearchSuggestionDetailRecord(questionUuid).then((res) => {
			if (res===undefined) return;
			getLoadingStatusForSearchSuggestions(false);
			if (res.data.data !== undefined && res.data.success) {
				getSeekerNameInSearchSuggestions(seekerName);
				getUserTypeInSearchSuggestions(userType);
				searchSuggestionsQuestionText(questionText)
				getPostedDateInSearchSuggestions(postedDate);
				getTagsDataInSearchSuggestions(tags);
				getAskedSourceForSearchSuggestions(source)
				getDomainNameInSearchSuggestionsDetailPage(domain);
				searchSuggestionsDetails(res.data.data);
				getGenAiAnswerSummary(genAIAnswer)
				getGenAIOverallRatingsData(Math.round(genAIOverallRating))
			}
		}).catch((err) => console.log(err));
		}else{
			getSeekerNameInSearchSuggestions(seekerName);
				getUserTypeInSearchSuggestions(userType);
				searchSuggestionsQuestionText(questionText)
				getPostedDateInSearchSuggestions(postedDate);
				getTagsDataInSearchSuggestions(tags);
				getAskedSourceForSearchSuggestions(source)
				getDomainNameInSearchSuggestionsDetailPage(domain);
				searchSuggestionsDetails([]);
				getGenAiAnswerSummary(genAIAnswer)
				getGenAIOverallRatingsData(Math.round(genAIOverallRating))
		}
	}

	const askSourceRender = (source) => {
		if (source === 'csv') {
			return (<span style={{ marginBottom: "0px", marginLeft: "5px" }}>&nbsp;via&nbsp;<Tooltip title="User added QA via XLS Atomizer">
				<i className="fa fa-file-excel-o" style={{ color: "#875c99" }}>
				</i></Tooltip>
			</span>)
		}
		if (source === 'Mobile')
			return (
				<><span>&nbsp;via&nbsp;</span><Tooltip title="User searched via Mobile Application"><img src={require('../../Images/32x32.png')} style={{ width: "16px" }} /></Tooltip></>
			)
		if (source === 'expert-QA') {
			return (
				<span>&nbsp;via&nbsp;<Tooltip title="User added QA via Expert role"><i class="fa fa-user-plus" aria-hidden="true" style={{ color: "#fb7432" }}></i></Tooltip></span>
			)
		}
		if (source === 'slack') {
			return (
				<><span>&nbsp;via&nbsp;</span><Tooltip title="User searched via Slack Vizerto bot"><img src={require("../../Images/slack-channel.png")} style={{ width: "16px" }} /></Tooltip></>
			)
		}
		if (source === 'slack-channel') {
			return (
				<><span>&nbsp;via&nbsp;</span><Tooltip title="User asked a question on slack channel"><img src={require("../../Images/slack-channel.png")} style={{ width: "16px" }} /></Tooltip></>
			)
		}
		if (source === 'msteams') {
			return (
				<><span>&nbsp;via&nbsp;</span><Tooltip title="User asked a question via MS Teams"><img src={require("../../Images/msteams.ico")} style={{ width: "16px" }} /></Tooltip></>
			)
		}
		if (source === 'msteams-channel') {
			return (
				<><span>&nbsp;via&nbsp;</span><Tooltip title="User asked a question via MS Teams Channel"><img src={require("../../Images/msteams.ico")} style={{ width: "16px" }} /></Tooltip></>
			)
		}
		if (source === 'webex') {
			return (
				<><span>&nbsp;via&nbsp;</span><Tooltip title="User asked a question via Webex"><img src={require("../../Images/webex.jpg")} style={{ width: "16px" }} /></Tooltip></>
			)
		}
		if (source === 'webex-channel') {
			return (
				<><span>&nbsp;via&nbsp;</span><Tooltip title="User asked a question via Webex Channel"><img src={require("../../Images/webex.jpg")} style={{ width: "16px" }} /></Tooltip></>
			)
		}
		if (source === 'email') {
			return (
				<><span>&nbsp;via&nbsp;<Tooltip title="User asked a question via Email"><i className="fa fa-envelope" aria-hidden="true" style={{ color: "#875c99" }}></i></Tooltip></span></>
			)
		}
		if (source === 'Multi-Question') {
			return (
				<>
					<Tooltip title={`User asked a question via ${source}`}>
						{/* <Tag style={{ fontFamily: 'inherit', backgroundColor: 'rgb(31, 147, 210)', color: '#fff', fontWeight: 'bold', fontSize: '11px' }}>{source}</Tag> */}
					<span>&nbsp;via&nbsp;<img src={require('../../Images/multiq.png')} style={{width:'20px',background:'#1f93d2'}} /></span>
					</Tooltip>
				</>
			)
		}
	}

	return (
		<Box sx={{ width: '100%',borderRadius:'6px'}}>
			<Paper sx={{ width: '100%', mb: 2 }}>
				{/* {selected.length > 0 && <EnhancedTableToolbar numSelected={selected.length} />} */}
				{
					selected.length > 0 ?
					<EnhancedTableToolbar numSelected={selected.length} /> :
					<Toolbar variant='dense' sx={{paddingTop:'2px',paddingBottom:'2px',paddingLeft:'15px'}}>
					<Typography
						sx={{ paddingTop: '4px', paddingBottom: '4px', display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}
						variant="h6"
						id="tableTitle"
						component="div">
						Search History
						 	<div>
							 {
									searchSuggestionsReducer.count === 0 &&
									<>
									<div className="searchSuggestionsCount">
										<span>
											0 to 0 of 0
										</span>
									</div>
									</>
								}
					 		{searchSuggestionsReducer.count > 0 && <div className="searchSuggestionsCount">
					 			{/* {searchSuggestionsReducer.page === 0 ? "1" : searchSuggestionsReducer.page + 1} to {searchSuggestionsReducer.searchSuggestionsData.length} of {searchSuggestionsReducer.count} */}
					 			{/* {searchSuggestionsReducer.page > 0 ? pageFrom : "1"} to {searchSuggestionsReducer.page > 0 ? pageTo : getDataLength} of {searchSuggestionsReducer.count} */}
							{
									searchSuggestionsReducer.page === 0 ? <><span>1 to {searchSuggestionsReducer.searchSuggestionsData.length} of {searchSuggestionsReducer.count.toLocaleString()}</span></>
										:
										<>
											<span>
												{(searchSuggestionsReducer.page === (Math.ceil(searchSuggestionsReducer.count / 20) - 1)) ? (searchSuggestionsReducer.count - searchSuggestionsReducer.searchSuggestionsData.length) + 1 : searchSuggestionsReducer.page * searchSuggestionsReducer.searchSuggestionsData.length + 1}
												{" "}to{" "}
												{searchSuggestionsReducer.page === (Math.ceil(searchSuggestionsReducer.count / 20) - 1) ? searchSuggestionsReducer.count : ((searchSuggestionsReducer.page) * (searchSuggestionsReducer.searchSuggestionsData.length) + (searchSuggestionsReducer.searchSuggestionsData.length))}
												{" "}of{" "}{searchSuggestionsReducer.count.toLocaleString()}
											</span>
										</>
								}
							</div>}
						</div>
					</Typography>
					</Toolbar>
				}
				{
					// ((searchSuggestionsReducer.excludeEmail) ||
					// 	(searchSuggestionsReducer.fromDate !== '') ||
					// 	(searchSuggestionsReducer.tillDate !== '') ||
					// 	(searchSuggestionsReducer.source !== '') ||
					// 	(searchSuggestionsReducer.isAccepted === true) ||
					// 	(searchSuggestionsReducer.seekersListInfo.length > 1) ||
					// 	(searchSuggestionsReducer.seekersListInfo.length > 0) ||
					// 	(searchSuggestionsReducer.expertsListInfo.length > 1) ||
					// 	(searchSuggestionsReducer.expertsListInfo.length > 0
					// 		&&
					// 		searchSuggestionsReducer.expertsListInfo.length === 1)
					// )
					// &&
					(searchSuggestionsReducer.isLoading === false) &&
					<FiltersToolbar 
					numSelected={selected.length}
					order={order}
					orderBy={orderBy}
					onSelectAllClick={handleSelectAllClick}
					rowCount={searchSuggestionsReducer.searchSuggestionsData.length} />
				}
				{
					searchSuggestionsReducer.isLoading === true &&
					<>
						<div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
							<CircularProgress />
						</div>
					</>
				}
				{
					searchSuggestionsReducer.count === 0 && searchSuggestionsReducer.isLoading === false &&
					<>
						<div style={{ display: 'flex', justifyContent: 'center', width: '100%', opacity: 0.66 }}>
							<img src={require('../../Images/nothing_found.png')} />
						</div>
						<h6 style={{ textAlign: 'center', fontWeight: '600', fontSize: '18px' }}>No records found.</h6>
					</>
				}
				<TableContainer>
					<Table
						sx={{ minWidth: 750 }}
						aria-labelledby="tableTitle"
						size={'medium'}
					>
							 {/* // <EnhancedTableHead
							// 	numSelected={selected.length}
							// 	order={order}
							// 	orderBy={orderBy}
							// 	onSelectAllClick={handleSelectAllClick}
							// 	rowCount={searchSuggestionsReducer.searchSuggestionsData.length}
							// ></EnhancedTableHead> */}
						{searchSuggestionsReducer.isLoading === false && searchSuggestionsReducer.count > 0 && <TableBody>
							{visibleRows.map((row, index) => {
								const isItemSelected = isSelected(row.id);
								const labelId = `enhanced-table-checkbox-${index}`;
								return (
									<TableRow
										hover
										role="checkbox"
										aria-checked={isItemSelected}
										tabIndex={-1}
										key={row.id}
										selected={isItemSelected}
										sx={{ cursor: 'default', fontSize: '30px' }}
									>
										<TableCell padding="checkbox">
											<Checkbox
												color="primary"
												size='small'
												// checked={(selected.indexOf(row.id) > -1)?true:false}
												checked={isItemSelected}
												inputProps={{
													'aria-labelledby': labelId,
												}}
												onClick={(event) => handleClick(event, row.id)}
											/>
										</TableCell>
										<TableCell
											component="th"
											id={labelId}
											scope="row"
											padding="none"
											sx={{ paddingTop: '7px', paddingBottom: '7px',width:'83%' }}
										>
											<VizParagraph type={5} weight={1}>
												<div onClick={() => onClickQuestionRecord(row.questionTopicUuid, row.seekerName, row.userType, row.questionText, row.postedDate, row.tags, row.source,row.domain,row.genAIAnswer,row.genAIOverallRating)} style={{ cursor: 'pointer', wordBreak: 'break-word',overflowWrap: 'break-word', fontWeight: 300, fontSize: '16px', paddingBottom: '3px' }}>
													{row.questionText}
												</div>
											</VizParagraph>
											<div style={{ display: 'flex',flexShrink:0 }} onClick={() => onClickQuestionRecord(row.questionTopicUuid, row.seekerName, row.userType, row.questionText, row.postedDate, row.tags, row.source,row.domain,row.genAIAnswer,row.genAIOverallRating)}>
												{/* <div style={{ cursor: 'pointer' }} className='suggestionsCount'>
													{
														row.suggestionCount > 1 ? <>{row.suggestionCount}&nbsp;Suggestions</> :
															<>
																{row.suggestionCount}&nbsp;Suggestion

															</>
													}
												</div> */}
													{ row.domain && row.domain !== '' && (
													<>
														<Tag color={"#878787"} style={{cursor:'pointer',fontFamily:'inherit',backgroundColor:'#878787',color:'#fff',fontSize:'11px'}} onClick={() => onClickQuestionRecord(row.questionTopicUuid, row.seekerName, row.userType, row.questionText, row.postedDate, row.tags, row.source,row.domain)}>{row.domain}</Tag>
													</>
												)}
												{
													row.summaryId && row.summaryId !== '' && row.genAIAnswer && row.genAIAnswer !== ''
													&&
													(
														<Tag color={"#1e93d2"} style={{fontSize:'11px', cursor: 'pointer', fontFamily: 'inherit',backgroundColor:'#1e93d2',color:'#fff' }}>GenAI Answer</Tag>
													)
												}
												{row.source !== "External Search" &&
													row.bestResult && 
													(<Tag color={"#57A13D"} style={{fontFamily:'inherit',cursor:'pointer',backgroundColor:'#57A13D',color:'#fff',fontSize:'11px'}}>Best Result</Tag>)
												}
												{row.source !== "External Search" &&
													row.submitted && (
														<Tag color={'#EF7828'} style={{fontSize:'11px',fontFamily:'inherit',cursor:'pointer',backgroundColor:'#EF7828',color:'#fff'}}>Q Submitted</Tag>
													)
												}
											
												{row.source !== "External Search" &&
													row.suggestionCount === 1 &&
													(
														<Tag color={"#075490"} style={{fontFamily:'inherit',cursor:'pointer',backgroundColor:'#075490',fontSize:'11px',color:'#fff'}}>
														{row.suggestionCount}&nbsp;Suggestion		
														</Tag>
													)
												}
												{row.source !== "External Search" &&
													row.suggestionCount > 1 && <>												
													<Tag color={"#075490"} style={{fontFamily:'inherit',cursor:'pointer',backgroundColor:'#075490',fontSize:'11px',color:'#fff'}}>
														{row.suggestionCount}&nbsp;Suggestions												
														</Tag>
													</>
												}
												{row.source !== "External Search" && row.suggestionCount === 0 && (
													<Tag color={"#EF7828"} style={{fontFamily:'inherit',backgroundColor:'#EF7828',color:'#fff',cursor:'pointer',fontSize:'11px'}}>{row.suggestionCount}{" "}Suggestions</Tag>
												)}
												
												{/* {row.acceptedCount === 0
													&&
													row.answeredCount === 0
													&&
													row.openCount === 0
													&&
													row.rejectedCount === 0
													&&
													<>
														<div className='noActionsText'>
															No Action
														</div>
													</>
												} */}
												{row.source !== "External Search" &&
													row.acceptedCount > 1
													&&
													// <div style={{ cursor: 'pointer' }} className='acceptedText'>
													// 	{row.acceptedCount}{" "}Accepted
													// </div>
													<Tag color={"#5d985d"} style={{ backgroundColor:'#5d985d',fontSize:'11px',color:'#fff', cursor: 'pointer', fontFamily: 'inherit' }}>{row.acceptedCount}{" "}Likes</Tag>
												}
												{row.source !== "External Search" &&
													row.acceptedCount === 1 &&
													<Tag color={"#5d985d"} style={{ backgroundColor:'#5d985d',cursor: 'pointer', fontFamily: 'inherit',color:'#fff' }}>{row.acceptedCount}{" "}Like</Tag>
												}
												{row.source !== "External Search" &&
													row.searchMethod === 'bert' &&
													<>
														{/* <div className='searchMethod'>
															AIBERT
														</div> */}
														<Tag color={"#1192D2"} style={{backgroundColor:"#1192D2",color:'#fff',fontFamily:'inherit',fontSize:'11px',cursor:'pointer'}}>AIBERT</Tag>
													</>
												}
												{row.source !== "External Search" &&
													row.rejectedCount > 1 && 
													<Tag color={"#EF3B24"} style={{fontFamily:'inherit',backgroundColor:'#EF3B24',color:'#fff',cursor:'pointer',fontSize:'11px'}}>{row.rejectedCount}{" "}Dislikes</Tag>
												}
												{row.source !== "External Search" &&
													
													row.rejectedCount === 1 &&
													<>
														<Tag color={"EF3B24"} style={{ fontFamily: 'inherit', backgroundColor: '#EF3B24', color: '#fff',cursor:'pointer',fontSize:'11px' }}>{row.rejectedCount}{" "}Dislike</Tag>
													</>
												}
												{row.source !== undefined && row.source === "External Search"  && (
													<Tag color={"#FF6600"} style={{fontFamily:'inherit',backgroundColor:'#FF6600',color:'#fff',cursor:'pointer',fontSize:'11px'}}>{row.source}</Tag>
												)}
											</div>
										</TableCell>
										<TableCell align='right' component="th" style={{ paddingTop: '7px', paddingBottom: '7px',width:'17%' }}>
											{/* Accepted Suggestion Count here */}
											<VizParagraph type={5} weight={1}>
												<span>
													<span>{momentit(row.postedDate)} by
													</span>
												</span>
												<div className='seekerPostedName' style={{ paddingBottom: '3px' }}>
													{row.seekerName}
													{
														<VizParagraph type={5} weight={1}>
															{askSourceRender(row.source)}
														</VizParagraph>
													}
												</div>
												{/* <div style={{textAlign:'right'}}>by</div> */}
												{/* {row.domain && row.acceptedCount > 0 &&
													<>
														<div className='domainNameCM' onClick={() => onClickQuestionRecord(row.questionTopicUuid, row.seekerName, row.userType, row.questionText, row.postedDate, row.tags, row.source)} style={{ fontSize: '12px', cursor: 'pointer' }}>
															{row.domain}
														</div>
													</>} */}
											</VizParagraph>
										</TableCell>
									</TableRow>
								);
							})}
							{/* {emptyRows > 0 && (
								<TableRow
									style={{
										height: (dense ? 33 : 53) * emptyRows,
									}}
								>
									<TableCell colSpan={6} />
								</TableRow>
							)} */}
						</TableBody>}
					</Table>
				</TableContainer>
				{/* <TablePagination
					rowsPerPageOptions={[20]}
					component="div"
					count={searchSuggestionsReducer.count}
					rowsPerPage={rowsPerPage}
					page={searchSuggestionsReducer.page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
					showFirstButton={true}
					showLastButton={true}
				/> */}
				<div>
					<Pagination sx={{ '& .MuiPagination-ul': { float: 'right',paddingTop:'6px' } }} size='large' count={Math.ceil(searchSuggestionsReducer.count / 20)} page={page} onChange={handleChangePage} />
				</div>
			</Paper>
		</Box>
	);
}









